import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';

const SocialLinks = () => {
	const links = [
		{
			id: 1,
			child: (
				<>
					Linkedin <FaLinkedin size={30} />
				</>
			),
			href: 'https://linkedin.com',
			style: 'rounded-tr-md',
		},
		{
			id: 2,
			child: (
				<>
					Github <FaGithub size={30} />
				</>
			),
			href: 'https://github.com/kokosikbuller',
		},
	];

	return (
		<div className='hidden lg:flex flex-col top-[35%] left-0 fixed'>
			<ul>
				{links.map(({ id, href, child }) => (
					<li
						key={id}
						className='flex justify-between items-center w-40 h-14 px-4 bg-gray-500
            ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300'
					>
						<a
							href={href}
							target='_blank'
							rel='noreferrer'
							className='flex justify-between items-center w-full text-white'
						>
							{child}
						</a>
					</li>
				))}
			</ul>
		</div>
	);
};

export default SocialLinks;
